export default __webpack_public_path__ + "static/media/023-eggs.89c33ed2.png";